import { Alert, Card, Tooltip } from "antd";
import { MdOutlineTask } from "react-icons/md";

import "../../../../../../../bgGlobal.css";

import "./style.css"


export function TabelasTarefas({
  setTarefaSelecionada,
  setIsSituacaoTarefa,
  slicedData,
  loading,
}) {


  return (
    <>
      <div className="tabela-container">

        {/* Cabeçalho da tabela */}
        <div className="tabela-header-task">
          <div className="col">Dia</div>
          <div className="col">Obrigação</div>
          <div className="col">Realizado/Previsto</div>
          <div className="col">Acessar</div>
        </div>

        {/* Linhas (Cards) */}
        <div className="tabela-grid">
          {slicedData != null && slicedData.length > 0 ? (
            <>

              {slicedData.map((item) => {


                return (

                  <Card
                    key={item.obrigacao.id}
                    size="small"
                    hoverable
                    className={`tabela-card ${item.quantidadeEmitido === item.quantidadePrevisto ? "tabela-card-finalizadas" : ""}`}
                  >

                    <div className="tabela-linha-task">
                      <div className="col">{item.obrigacao.dia}</div>
                      <div className="col">
                        {item.obrigacao.sigla}
                        <br />
                        {item.obrigacao.nome}
                      </div>
                      <div className="col">
                        <span>{item.quantidadeEmitido}</span> /
                        <span>{item.quantidadePrevisto}</span>
                      </div>

                      <div className="col" style={{display: "flex", justifyContent: "center"}}>
                        <Tooltip title="Tarefas">
                          <div
                            disabled={loading}
                            className="sty-btn bg-padrao font-icon"
                            onClick={() => {
                              setTarefaSelecionada(item.obrigacao.id);
                              setIsSituacaoTarefa(true);
                            }}
                          >
                            <MdOutlineTask />
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  </Card>

                );
              })}
            </>

          ) : (
            <Alert message="Nenhuma tarefa encontrada" type="info" showIcon />
          )}
        </div>


      </div>
    </>
  );
}

export default TabelasTarefas;
